/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-11T13:35:40.795Z by lizhutang (lizhutang@spolo.org)

'use strict'

const defTextContent = '这里是占位文字，双击可以修改：WIDE是WWARE的集成开发环境。可以快速开发复杂逻辑的智能应用。支持开发标准HTML5应用，微信/易信应用，APP(Android，iOS，WinPhone)，智能电视，标准PC软件(Windows,Linux,Mac OS)的开发。'
const defDIVContent = 'DIV容器可以当作文本段来使用，双击可以修改文字，这一点与文本段元素相同。但是DIV容器可以容纳其它元素(观测右方元素树)。DIV容器一旦有子元素，将不再拥有文本编辑特性。因此，您需要在插入其它元素之前，清空这里的文本内容。'
const mainLayerName = '_wwmain'

export default {
  defTextContent: defTextContent,
  defDIVContent: defDIVContent,
  mainLayerName: mainLayerName
}
